<template>
  <div class="category-page">
    <h1>这是我的页面</h1> <!-- 必须有可见内容 -->
    <p></p>
  </div>
</template>